import React, { useState } from 'react';

const AlbumPhotoCard = ({ photo, pets, currentUser, onAddComment }) => {
  const [comment, setComment] = useState('');
  const [showComments, setShowComments] = useState(false);

  const canView = currentUser.isStaff || 
                 photo.taggedPets.some(petId => 
                   pets.find(p => p.id === petId)?.ownerId === currentUser.id);

  if (!canView) return null;

  return (
    <div className="bg-white rounded-xl shadow-sm overflow-hidden">
      <img src={photo.imageUrl} alt={photo.petName} className="w-full h-48 object-cover" />
      
      <div className="p-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <img 
              src={pets.find(p => p.id === photo.taggedPets[0])?.avatar} 
              alt="Pet" 
              className="w-8 h-8 rounded-full mr-2"
            />
            <span className="font-medium">{photo.petName}</span>
          </div>
          <span className="text-sm text-gray-500">{photo.date}</span>
        </div>

        <div className="mt-2 flex items-center">
          <span className="bg-cyan-100 text-cyan-800 text-xs px-2 py-1 rounded-full">
            {photo.activity}
          </span>
        </div>

        <div className="mt-4 flex space-x-3">
          <button className="text-gray-500 hover:text-gray-700">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
            </svg>
          </button>
          <button className="text-gray-500 hover:text-gray-700">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.368 2.684 3 3 0 00-5.368-2.684z" />
            </svg>
          </button>
          <button 
            className="text-gray-500 hover:text-gray-700"
            onClick={() => setShowComments(!showComments)}
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
            </svg>
          </button>
        </div>

        {showComments && (
          <div className="mt-4">
            {photo.comments.map((c, i) => (
              <div key={i} className="text-sm mb-2">
                <span className="font-medium">{users.find(u => u.id === c.userId)?.name}: </span>
                <span>{c.text}</span>
              </div>
            ))}
            
            <div className="mt-3 flex">
              <input
                type="text"
                value={comment}
                onChange={(e) => setComment(e.target.value)}
                placeholder="Añadir comentario..."
                className="flex-1 px-3 py-1 border border-gray-300 rounded-l-md focus:outline-none focus:ring-1 focus:ring-cyan-500"
              />
              <button 
                onClick={() => {
                  onAddComment(photo.id, comment);
                  setComment('');
                }}
                className="bg-cyan-600 text-white px-3 py-1 rounded-r-md hover:bg-cyan-700"
              >
                Enviar
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default AlbumPhotoCard;